/*!
 * Copyright 2022 Thorne Health Lab. All rights reserved.
 */
import React from 'react';
import ContinueSurvey from '../../components/ContinueSurvey';
import { useSnackbar } from 'react-simple-snackbar';
import { ReactComponent as IconSuccess } from '../../assets/icons/IconSuccess.svg';
import { ReactComponent as IconWarning } from '../../assets/icons/IconWarning.svg';
import { authRoutes } from '../../root/routes';
import Text from '../../components/text';
import Element from '../../components/element';
import Flex from '../../components/flex';

const useToast = () => {
  const [open] = useSnackbar({
    position: 'top-center',
    style: {
      backgroundColor: 'white',
      borderRadius: '4px',
      padding: '6px 8px',
      width: 'auto',
      height: '36px',
      color: 'black'
    }
  });
  const handleSnackbar = (text, type) => {
    open(
      <Flex align="center">
        <Element
          type={type === 'warn' ? IconWarning : IconSuccess}
          width="24px"
          height="24px"
        />
        <Text marginLeft="10px">{text}</Text>
      </Flex>
    );
  };
  const openSnackbar = handleSnackbar;
  return [openSnackbar];
};

export default useToast;
